import React from 'react';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';

const AnimatedSection = ({ children, className = '', delay = 0, animation = 'fade-up' }) => {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const animationClasses = {
    'fade-up': 'translate-y-12 opacity-0',
    'fade-in': 'opacity-0',
    'fade-left': 'translate-x-12 opacity-0',
    'fade-right': '-translate-x-12 opacity-0',
    'scale': 'scale-95 opacity-0'
  };

  const baseClasses = animationClasses[animation] || animationClasses['fade-up'];

  return (
    <div
      ref={ref}
      className={`transition-all duration-1000 ease-out ${
        isVisible ? 'translate-y-0 translate-x-0 scale-100 opacity-100' : baseClasses
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;